import { useState } from 'react';

import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import LoginStore from '../../../stores/LoginStore';

const LoginPanel = ({ isLoggedIn }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [
        didPressSubmitButtonAtLeastOnce,
        setDidPressSubmitButtonAtLeastOnce,
    ] = useState(false);
    const [isPasswordMasked, setIsPasswordMasked] = useState(false);

    const loginStore = LoginStore((state) => state);

    return render();

    return (
        <>
            <main className="main">
                <section className="contact">
                    <div style={{ width: '40%' }}>
                        <div className="login-i4s center-in-screen-center-position-absolute">
                            <div
                                className="background-grey GGC-XL-CBHB"
                                style={{ margin: 'auto' }}
                            >
                                <h1 className="headings">
                                    <img
                                        alt="Duo"
                                        style={{ width: '300px' }}
                                        src="images/ai2teach-logo.png"
                                    />
                                </h1>

                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                align="left"
                                                style={{ verticalAlign: 'top' }}
                                            >
                                                <div
                                                    className="input-group login-area"
                                                    style={{
                                                        width: '300px',
                                                        margin: '10px',
                                                    }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        id="basic-addon1"
                                                    >
                                                        {' '}
                                                        <span
                                                            aria-hidden="true"
                                                            className="glyphicon glyphicon-user"
                                                        ></span>{' '}
                                                    </span>

                                                    <FormControl
                                                        type="text"
                                                        aria-describedby="basic-addon1"
                                                        id="namebox"
                                                        placeholder="Benutzername ..."
                                                        autoComplete="on"
                                                        autoCorrect="off"
                                                        onInput={(e) => {
                                                            var username =
                                                                e.target.value; //.toLowerCase();

                                                            setUsername(
                                                                username,
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                align="left"
                                                style={{ verticalAlign: 'top' }}
                                            >
                                                <div
                                                    className="input-group login-area"
                                                    style={{
                                                        width: '300px',
                                                        marginLeft: '10px',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        id="basic-addon2"
                                                    >
                                                        {' '}
                                                        <span
                                                            aria-hidden="true"
                                                            className="glyphicon glyphicon-lock"
                                                        ></span>{' '}
                                                    </span>

                                                    <FormControl
                                                        type={
                                                            isPasswordMasked
                                                                ? 'password'
                                                                : 'text'
                                                        }
                                                        aria-describedby="basic-addon2"
                                                        autoComplete="on"
                                                        id="password-box"
                                                        placeholder="Passwort ..."
                                                        onInput={(e) => {
                                                            var password =
                                                                e.target.value;
                                                            setPassword(
                                                                password,
                                                            );
                                                        }}
                                                    />

                                                    <span
                                                        className="input-group-addon GGC-XL-CDHB"
                                                        id="password-box-addon"
                                                    >
                                                        <button
                                                            type="button"
                                                            className="GGC-XL-CCHB"
                                                            onClick={() => {
                                                                if (
                                                                    isPasswordMasked
                                                                ) {
                                                                    setIsPasswordMasked(
                                                                        false,
                                                                    );
                                                                } else {
                                                                    setIsPasswordMasked(
                                                                        true,
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            <span
                                                                aria-hidden="true"
                                                                className="glyphicon glyphicon-eye-open"
                                                            ></span>
                                                        </button>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                align="left"
                                                style={{ verticalAlign: 'top' }}
                                            >
                                                {didPressSubmitButtonAtLeastOnce /*&& null != LoginStore.getData() 
								&& ! LoginStore.checkLoggedIn()*/
                                                    ? 'That combination of user and password is unknown.'
                                                    : null}

                                                <button
                                                    type="button"
                                                    className="btn btn-lg btn-block rounded-btn background-color-diesterweg"
                                                    onClick={() => {
                                                        setDidPressSubmitButtonAtLeastOnce(
                                                            true,
                                                        );

                                                        loginStore.checkCredentials(
                                                            username,
                                                            password,
                                                        );
                                                    }}
                                                >
                                                    Anmelden
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                align="left"
                                                style={{ verticalAlign: 'top' }}
                                            ></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );

    function render() {
        return (
            <div style={{ width: '40%' }}>
                <div className="center-in-screen-center-position-absolute">
                    <div
                        className="background-grey GGC-XL-CBHB"
                        style={{ margin: 'auto' }}
                    >
                        <h1 className="headings">
                            <img
                                alt="Duo"
                                style={{ width: '300px' }}
                                src="/static/media/duo-digital-und-offen-tu-cede-logo-colors-1.75ab43a77149d16a6508.png"
                            />
                        </h1>

                        <table>
                            <tbody>
                                <tr>
                                    <td
                                        align="left"
                                        style={{ verticalAlign: 'top' }}
                                    >
                                        <div
                                            className="input-group login-area"
                                            style={{
                                                width: '300px',
                                                margin: '10px',
                                            }}
                                        >
                                            <span
                                                className="input-group-addon"
                                                id="basic-addon1"
                                            >
                                                {' '}
                                                <span
                                                    aria-hidden="true"
                                                    className="glyphicon glyphicon-user"
                                                ></span>{' '}
                                            </span>

                                            <FormControl
                                                type="text"
                                                aria-describedby="basic-addon1"
                                                id="namebox"
                                                placeholder="Benutzername ..."
                                                autoComplete="on"
                                                autoCorrect="off"
                                                onInput={(e) => {
                                                    var username =
                                                        e.target.value; //.toLowerCase();

                                                    setUsername(username);
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        align="left"
                                        style={{ verticalAlign: 'top' }}
                                    >
                                        <div
                                            className="input-group login-area"
                                            style={{
                                                width: '300px',
                                                marginLeft: '10px',
                                                marginRight: '10px',
                                            }}
                                        >
                                            <span
                                                className="input-group-addon"
                                                id="basic-addon2"
                                            >
                                                {' '}
                                                <span
                                                    aria-hidden="true"
                                                    className="glyphicon glyphicon-lock"
                                                ></span>{' '}
                                            </span>

                                            <FormControl
                                                type={'password'}
                                                aria-describedby="basic-addon2"
                                                autoComplete="on"
                                                id="password-box"
                                                placeholder="Passwort ..."
                                                onInput={(e) => {
                                                    var password =
                                                        e.target.value;
                                                    setPassword(password);
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        align="left"
                                        style={{ verticalAlign: 'top' }}
                                    >
                                        <div
                                            className="w-100 "
                                            style={{ marginTop: '15px' }}
                                        >
                                            {didPressSubmitButtonAtLeastOnce &&
                                            null == loginStore.userData &&
                                            !loginStore.isLoggedIn
                                                ? 'That combination of user and password is unknown.'
                                                : null}
                                        </div>

                                        <Button
                                            type="button"
                                            className="w-100 btn btn-lg btn-primary btn btn-primary"
                                            style={{ marginTop: '15px' }}
                                            onClick={() => {
                                                setDidPressSubmitButtonAtLeastOnce(
                                                    true,
                                                );

                                                loginStore.checkCredentials(
                                                    username,
                                                    password,
                                                );
                                            }}
                                        >
                                            Anmelden
                                        </Button>
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        align="left"
                                        style={{ verticalAlign: 'top' }}
                                    >
                                        <div>
                                            {/*self.buildSupportAlert()*/}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
};

export default LoginPanel;
